export const destructurePathName = (pathname: string): [string, string] => {
  if (!pathname.includes('/')) {
    return ['', ''];
  }
  const array = pathname.split('/');
  return [array[1] as string, array[2] as string];
};
